import { render, staticRenderFns } from "./GetterTestsDevPage.vue?vue&type=template&id=6a39bb7d&scoped=true&"
import script from "./GetterTestsDevPage.vue?vue&type=script&lang=js&"
export * from "./GetterTestsDevPage.vue?vue&type=script&lang=js&"
import style0 from "./GetterTestsDevPage.vue?vue&type=style&index=0&id=6a39bb7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a39bb7d",
  null
  
)

export default component.exports